import Client from './client';

export default class MarketingGatewayFacebookBusinesses extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  getCatalogs(organization, businessId, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/marketing/gateway/facebook/${businessId}/catalogs`, options);
  }

}
